var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.333,
    height: 10.335,
    viewBox: "36 13.411 10.333 10.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m46.193 22.346-2.012-2.012a.484.484 0 0 0-.343-.141h-.33A4.198 4.198 0 1 0 36 17.609a4.198 4.198 0 0 0 6.782 3.31v.33c0 .128.05.251.141.342l2.013 2.013c.19.19.496.19.684 0l.571-.572c.19-.19.19-.496.002-.686Zm-5.995-2.153a2.582 2.582 0 0 1-2.583-2.584 2.582 2.582 0 0 1 2.583-2.584 2.582 2.582 0 0 1 2.584 2.584 2.582 2.582 0 0 1-2.584 2.584Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Icon awesome-search"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.77c76471888340aa8730f67f2a1abf97.svg";
export { ForwardRef as ReactComponent };